import * as __shell from 'virtual:muten/shell';
import { route, injectCss } from 'virtual:muten/runtime';


const routes = {
  "/": { load: () => import("/src/pages/home/home.muten") },
  "/privacy": { load: () => import("/src/pages/privacy/privacy.muten") },
  "/terms": { load: () => import("/src/pages/terms/terms.muten") },
};
const root = document.getElementById('app');
if (root) {
  injectCss(__shell.css);
  const outlet = __shell.mount(root);
  route(outlet, routes);
}
